<template>
    <div class="commerce-filter-projects">
        <div class="container">
            <div class="filter-container" v-click-outside="onClickOutside" :class="{'openMobile': isOpenFilterMobile}">
                <div class="mobile-filter-header" v-if="isMobileChecker">
                    <h2><span>{{ filterCMSparams.words_translation.filter_title_filter_mobile }}</span></h2>
                    <a href="#" class="close-link" @click.prevent="closeMobileFilter"><svgIcon name="close" class="icon-svg"/></a>
                </div>
                <div class="btn-find-info" v-if="isMobileChecker">
                    <a href="#" @click.prevent="closeMobileFilter">
                        <commerceFindNum class="btn-find"></commerceFindNum>
                    </a>
                </div>
                <div class="top-items">
                    <!-- FILTER COMPLEX -->
                    <div class="dropwdown-filter-select dropwdown-complex">
                        <div class="drop-filter-name" :class="{'open' : open_dropComplex}">
                            <a href="#" @click.prevent="open_dropComplex = !open_dropComplex, open_dropPart = false, open_dropClass = false">{{filterCMSparams.commerce_filter.sales.name}}</a>
                            <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                        </div>
                        <div class="dropdown-menu" :class="{'open' : open_dropComplex}">
                            <div class="mobile-filter-drop-header" v-if="isMobileChecker">
                                <a href="#" class="close-arrow" @click.prevent="open_dropComplex = !open_dropComplex"><svgIcon name="arrow-drop" class="icon-svg"/></a>
                                <h2>{{filterCMSparams.commerce_filter.sales.name}}</h2>
                                <a href="#" class="close-link" @click.prevent="closeMobileFilter"><svgIcon name="close" class="icon-svg"/></a>
                            </div>
                            <div class="drop-checkbox-container">
                                <div class="item-R" v-for="item in filterCMSparams.commerce_filter.sales.sales_list">
                                    <input type="checkbox" :id="item.slug" :value="item.slug" v-model="filterCommerceDataBase.complexChecked" @change="filterSalesItems()"> 
                                    <label :for="item.slug">{{item.name}}</label>
                                </div>
                            </div>
                            <div class="btn-save" v-if="isMobileChecker">
                                <a href="#" @click.prevent="open_dropComplex = !open_dropComplex"><span>{{ filterCMSparams.words_translation.filter_btn_save_mobile }}</span></a>
                            </div>
                        </div>
                    </div>
                    <!-- END FILTER COMPLEX -->
                    <!-- FILTER PARTS -->
                    <div class="dropwdown-filter-select dropwdown-part">
                        <div class="drop-filter-name" :class="{'open' : open_dropPart}">
                            <a href="#" @click.prevent="open_dropPart = !open_dropPart, open_dropComplex = false, open_dropClass = false">{{filterCMSparams.commerce_filter.parts.name}}</a>
                            <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                        </div>
                        <div class="dropdown-menu" :class="{'open' : open_dropPart}">
                            <div class="mobile-filter-drop-header" v-if="isMobileChecker">
                                <a href="#" class="close-arrow" @click.prevent="open_dropPart = !open_dropPart"><svgIcon name="arrow-drop" class="icon-svg"/></a>
                                <h2>{{filterCMSparams.commerce_filter.parts.name}}</h2>
                                <a href="#" class="close-link" @click.prevent="closeMobileFilter"><svgIcon name="close" class="icon-svg"/></a>
                            </div>
                            <div class="drop-checkbox-container" v-if="globalLang != 'kz/'">
                                <div class="item-R" v-for="item in filterCMSparams.commerce_filter.parts.parts_list">
                                    <input type="checkbox" :id="item.value" :value="item.value" v-model="filterCommerceDataBase.partsChecked" @change="filterSalesItems()"> 
                                    <label :for="item.value">{{item.label}}</label>
                                </div>
                            </div>
                            <div class="drop-checkbox-container" v-if="globalLang == 'kz/'">
                                <div class="item-R" v-for="item in filterCMSparams.commerce_filter.parts.parts_list_kz">
                                    <input type="checkbox" :id="item.value" :value="item.value" v-model="filterCommerceDataBase.partsChecked" @change="filterSalesItems()"> 
                                    <label :for="item.value">{{item.label}}</label>
                                </div>
                            </div>
                            <div class="btn-save" v-if="isMobileChecker">
                                <a href="#" @click.prevent="open_dropPart = !open_dropPart"><span>{{ filterCMSparams.words_translation.filter_btn_save_mobile }}</span></a>
                            </div>
                        </div>
                    </div>
                    <!-- END FILTER PARTS -->
                    <!-- FILTER PARTS -->
                    <!-- <div class="dropwdown-filter-select dropwdown-class">
                        <div class="drop-filter-name" :class="{'open' : open_dropClass}">
                            <a href="#" @click.prevent="open_dropClass = !open_dropClass, open_dropComplex = false, open_dropPart = false">{{filterCMSparams.commerce_filter.type.name}}</a>
                            <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                        </div>
                        <div class="dropdown-menu" :class="{'open' : open_dropClass}">
                            <div class="mobile-filter-drop-header" v-if="isMobileChecker">
                                <a href="#" class="close-arrow" @click.prevent="open_dropClass = !open_dropClass"><svgIcon name="arrow-drop" class="icon-svg"/></a>
                                <h2>{{filterCMSparams.commerce_filter.type.name}}</h2>
                                <a href="#" class="close-link" @click.prevent="closeMobileFilter"><svgIcon name="close" class="icon-svg"/></a>
                            </div>
                            <simplebar data-simplebar-auto-hide="false" class="dropdown-scroll-container">
                                <div class="drop-checkbox-container">
                                    <div class="item-R" v-for="item in filterCMSparams.commerce_filter.type.types_list">
                                        <input type="checkbox" :id="item.slug" :value="item.slug" v-model="filterCommerceDataBase.classChecked" @change="filterSalesItems()"> 
                                        <label :for="item.slug">{{item.name}}</label>
                                    </div>
                                </div>
                            </simplebar>
                            <div class="btn-save" v-if="isMobileChecker">
                                <a href="#" @click.prevent="open_dropClass = !open_dropClass"><span>Сохранить</span></a>
                            </div>
                        </div>
                    </div> -->
                    <!-- END FILTER PARTS -->
                    <div class="dropwdown-filter-select dropwdown-btns" v-if="!isMobileChecker">
                        <div class="drop-checkbox-single">
                            <div class="item-check">
                                <input type="checkbox" id="actions_btn" v-model="filterCommerceDataBase.actions" @change="filterSalesItems()"> 
                                <label for="actions_btn">{{filterCMSparams.commerce_filter.sales_btn_desc}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom-items">
                    <!-- RANGE SIZE -->
                    <div class="drop-filter-item drop-filter-size">
                        <span>{{filterCMSparams.commerce_filter.size.name}}</span>
                        <div class="filter size-filter range-filter" v-if="filterCommerceDataBase.initRangeSliders">
                            <div class="filter-inputs filter-inputs-size">
                                <div class="input-item">
                                    <span class="start">от</span>
                                    <input type="number" name="minSize" class="form-control" v-model.lazy="filterCommerceDataBase.size[0]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                    <span class="end">м²</span>
                                </div>
                                <div class="input-item">
                                    <span class="start">до</span>
                                    <input type="number" name="maxSize" class="form-control" v-model.lazy="filterCommerceDataBase.size[1]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                    <span class="end">м²</span>
                                </div>
                            </div>
                            <!-- @change="filterSalesItems()" -->
                            <div class="parking-filter-range-slider">
                                <div class="filter" id="SizeFilterCommerce">
                                    <input type="text" id="size-filter-commerce" name="size"  class="ionRangeSlider" value="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- RANGE PRICE -->
                    <div class="drop-filter-item drop-filter-price">
                        <span>{{filterCMSparams.commerce_filter.price.name}}</span>
                        <div class="filter size-filter range-filter" v-if="filterCommerceDataBase.initRangeSliders">
                            <div class="filter-inputs filter-inputs-size">
                                <div class="input-item">
                                    <span class="start">от</span>
                                    <input type="number" name="minPrice" class="form-control" v-model.lazy="filterCommerceDataBase.price[0]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                    <span class="end">млн</span>
                                </div>
                                <div class="input-item">
                                    <span class="start">до</span>
                                    <input type="number" name="maxPrice" class="form-control" v-model.lazy="filterCommerceDataBase.price[1]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                    <span class="end">млн</span>
                                </div>
                            </div>
                            <!-- @change="filterSalesItems()" -->
                            <div class="parking-filter-range-slider">
                                <div class="filter" id="PriceFilterCommerce">
                                    <input type="text" id="price-filter-commerce" name="size"  class="ionRangeSlider" value="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="drop-filter-item drop-filter-btns">
                        <span>{{filterCMSparams.commerce_filter.level.name}}</span>
                        <div class="filter level-filter range-filter" v-if="filterCommerceDataBase.initRangeSliders">
                            <div class="filter-inputs filter-inputs-size">
                                <div class="input-item">
                                    <span class="start">от</span>
                                    <input type="number" name="minLevel" class="form-control" v-model.lazy="filterCommerceDataBase.level[0]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                </div>
                                <div class="input-item">
                                    <span class="start">до</span>
                                    <input type="number" name="maxLevel" class="form-control" v-model.lazy="filterCommerceDataBase.level[1]" @focusout="validateInput" @keyup.enter="validateInput" oninput="this.value = !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                </div>
                            </div>
                            <!-- @change="filterSalesItems()" -->
                            <div class="parking-filter-range-slider">
                                <div class="filter" id="LevelFilterCommerce">
                                    <input type="text" id="level-filter-commerce" name="level"  class="ionRangeSlider" value="" />
                                </div>
                            </div>
                        </div>
                        <!-- @change="filterSalesItems()" -->
                        <!-- <div class="filter level-items">
                            <div class="item-R" v-for="item in filterCMSparams.commerce_filter.level.level">
                                <input type="checkbox" :id="'level_' + item" :value="item" v-model="filterCommerceDataBase.levelQuantities" @change="filterSalesItems()">
                                <label :for="'level_' + item">{{item}}</label>
                            </div>
                        </div> -->
                    </div>
                    <div class="drop-filter-item dropwdown-btns" v-if="isMobileChecker">
                        <div class="drop-checkbox-single">
                            <div class="item-check">
                                <input type="checkbox" id="actions_btn" v-model="filterCommerceDataBase.actions" @change="filterSalesItems()"> 
                                <label for="actions_btn">{{filterCMSparams.commerce_filter.sales_btn_desc}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="drop-filter-item drop-filter-reset" v-if="!isMobileChecker">
                        <div class="btn-reset-filter" @click.prevent="reloadFilter">
                            <span>{{ filterCMSparams.words_translation.filter_btn_clearfilter }}</span>
                            <svgIcon name="close-filter" class="icon-close"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mobile-filter-container" v-if="isMobileChecker">
                <div class="mobile-filter-btns">
                    <a href="#" @click.prevent="openMobileFilter">
                        <span>{{ filterCMSparams.commerce_filter.btn_filter_mobile_name }}</span>
                        <svgIcon name="filter" class="icon-svg"/>
                    </a>
                    <a href="#" @click.prevent="openMobileShorting" class="shorting-link" v-if="shortingParam != null">
                        <div class="short-icon">
                            <svgIcon name="shorting-up" class="icon-up" v-if="shortingParam.type == 'ascending'"/>
                            <svgIcon name="shorting-down" class="icon-down" v-if="shortingParam.type == 'descending'"/>
                        </div>
                        <span>{{ shortingParam.name }}</span>
                        <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                    </a>
                    <div class="down-btns">
                        <commerceViewBtns></commerceViewBtns>
                        <div class="btn-reset-filter-mobile" @click="reloadFilter">
                            <span>{{ filterCMSparams.words_translation.filter_btn_clearfilter }}</span>
                            <svgIcon name="close-filter" class="icon-close"/>
                        </div>
                    </div>
                </div>
                <div class="btns-bottom-controls">
                    <commerceFindNum></commerceFindNum>
                </div>
            </div>
            <commerceShorting class="mobile-shorting" :class="{'open' : isOpenShortingMobile}" v-if="isMobileChecker && shortingParam != null && commerceItems != null"></commerceShorting>
        </div>
    </div>
</template>

<script>
    import commerceFindNum from '@/components/commerce-page/commerce-find-num.vue'
    import commerceViewBtns from '@/components/commerce-page/commerce-view-btns.vue'
    import commerceShorting from '@/components/filters/commerce-filter/shorting-filter.vue'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import simplebar from 'simplebar-vue';
    import 'simplebar-vue/dist/simplebar.min.css';
    import {mapGetters} from 'vuex'
    export default {
        name: 'commerce-filter-projects',
        components: {
            svgIcon,
            simplebar,
            commerceFindNum,
            commerceViewBtns,
            commerceShorting,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                routerName: this.$router.history.current.name,
                open_dropComplex: false,
                open_dropPart: false,
                open_dropClass: false,
                SizeFilter: null,
                PriceFilter: null,
            }
        },
        computed: mapGetters({
            commerceItems: 'loadCommerceItems',
            commerceItemsDefault: 'loadCommerceItemsDefault',
            shortingParam: 'loadCommerceShortingParams',
            isMobileChecker: 'loadIsMobileChecker',
            //
            filterCMSparams: 'loadFilterCMSparams',
            filterCommerceDataBase: 'loadFilterCommerceData',
            isOpenFilterMobile: 'loadOpenCommerceMobileFilter',
            isOpenShortingMobile: 'loadOpenCommerceMobileShorting',
        }),
        methods: {
            setDataInSalesDataBase(param, data) {
                this.$store.commit('FilterCommerce_update_base', {name: param, data: data});
                this.filterSalesItems();
            },
            onClickOutside() {
                this.open_dropComplex = false;
                this.open_dropPart = false;
                this.open_dropClass = false;
            },
            validateInput(e) {
                const minSize_default = parseInt(this.filterCMSparams.commerce_filter.size.min);
                const maxSize_default = parseInt(this.filterCMSparams.commerce_filter.size.max);
                const minPrice_default = parseInt(this.filterCMSparams.commerce_filter.price.min);
                const maxPrice_default = parseInt(this.filterCMSparams.commerce_filter.price.max);
                const minLevel_default = parseInt(this.filterCMSparams.commerce_filter.level.min);
                const maxLevel_default = parseInt(this.filterCMSparams.commerce_filter.level.max);

                // console.log(e.target.value, e.target.name, this.filterCommerceDataBase.size[1]);
                //--// -- CHECK FOR SIZE FILTER RANGE
                if (e.target.name == 'minSize') {
                    if (parseInt(e.target.value) < minSize_default) {
                        e.target.value = minSize_default;
                        this.$store.commit('FilterCommerce_update_base', {name: 'sizeUpdate', param: 'min', data: minSize_default});
                    } else if (parseInt(e.target.value) > this.filterCommerceDataBase.size[1]) {
                        e.target.value = this.filterCommerceDataBase.size[1];
                        this.$store.commit('FilterCommerce_update_base', {name: 'sizeUpdate', param: 'min_max', data: this.filterCommerceDataBase.size[1]});
                    }
                } else if (e.target.name == 'maxSize') {
                    if (parseInt(e.target.value) > maxSize_default) {
                        e.target.value = maxSize_default;
                        this.$store.commit('FilterCommerce_update_base', {name: 'sizeUpdate', param: 'max', data: maxSize_default});
                    } else if (parseInt(e.target.value) < this.filterCommerceDataBase.size[0]) {
                        e.target.value = this.filterCommerceDataBase.size[0];
                        this.$store.commit('FilterCommerce_update_base', {name: 'sizeUpdate', param: 'max_max', data: this.filterCommerceDataBase.size[0]});
                    }
                } 
                //--//-- CHECK FOR PRICE FILTER RANGE
                else if (e.target.name == 'minPrice') {
                    if (parseInt(e.target.value) < minPrice_default) {
                        e.target.value = minPrice_default;
                        this.$store.commit('FilterCommerce_update_base', {name: 'priceUpdate', param: 'min', data: minPrice_default});
                    } 
                    else if (parseInt(e.target.value) > this.filterCommerceDataBase.price[1]) {
                        e.target.value = this.filterCommerceDataBase.price[1];
                        this.$store.commit('FilterCommerce_update_base', {name: 'priceUpdate', param: 'min_max', data: this.filterCommerceDataBase.price[1]});
                    } 
                }
                else if (e.target.name == 'maxPrice') {
                    if (parseInt(e.target.value) > maxPrice_default) {
                        e.target.value = maxPrice_default;
                        this.$store.commit('FilterCommerce_update_base', {name: 'priceUpdate', param: 'max', data: maxPrice_default});
                    } else if (parseInt(e.target.value) < this.filterCommerceDataBase.price[0]) {
                        e.target.value = this.filterCommerceDataBase.price[0];
                        this.$store.commit('FilterCommerce_update_base', {name: 'priceUpdate', param: 'max_max', data: this.filterCommerceDataBase.price[0]});
                    }
                }

                //--//-- CHECK FOR PRICE FILTER RANGE
                else if (e.target.name == 'minLevel') {
                    if (parseInt(e.target.value) < minLevel_default) {
                        e.target.value = minLevel_default;
                        this.$store.commit('FilterCommerce_update_base', {name: 'levelUpdate', param: 'min', data: minLevel_default});
                    } 
                    else if (parseInt(e.target.value) > this.filterCommerceDataBase.level[1]) {
                        e.target.value = this.filterCommerceDataBase.level[1];
                        this.$store.commit('FilterCommerce_update_base', {name: 'levelUpdate', param: 'min_max', data: this.filterCommerceDataBase.level[1]});
                    } 
                }
                else if (e.target.name == 'maxLevel') {
                    if (parseInt(e.target.value) > maxLevel_default) {
                        e.target.value = maxLevel_default;
                        this.$store.commit('FilterCommerce_update_base', {name: 'priceUpdate', param: 'max', data: maxLevel_default});
                    } else if (parseInt(e.target.value) < this.filterCommerceDataBase.level[0]) {
                        e.target.value = this.filterCommerceDataBase.level[0];
                        this.$store.commit('FilterCommerce_update_base', {name: 'levelUpdate', param: 'max_max', data: this.filterCommerceDataBase.level[0]});
                    }
                }

                this.updateIONrangeSlider();
                this.filterSalesItems();
            },
            BuildIonRangeSlider() {
                var _self = this;
                // console.log(_self.filterMinMaxParams, '212312312123123')
                _self.SizeFilter = $('#size-filter-commerce');
                _self.PriceFilter = $('#price-filter-commerce');
                _self.LevelFilter = $('#level-filter-commerce');
                _self.SizeFilter.ionRangeSlider({
                    type: "double",
                    min: parseInt(_self.filterCMSparams.commerce_filter.size.min),
                    max: parseInt(_self.filterCMSparams.commerce_filter.size.max),
                    from: _self.filterCommerceDataBase.size[0],
                    to: _self.filterCommerceDataBase.size[1],
                    step: 1,
                    hide_min_max: true,
                    onChange: function (data) {
                        _self.$store.commit('FilterCommerce_update_base', {name: 'sizeUpdate', param: 'rangeSlider', data: {min: data.from, max: data.to}})
                        _self.filterSalesItems(); 
                    },
                    // onUpdate: function (data) {
                    //     // console.log(data, 'update')
                    //     _self.$store.commit('FilterDataUpdate', {type: 'size-filter', min: data.from, max: data.to})
                    //     // _self.updateFilterDataBase();
                    // },
                });
                _self.PriceFilter.ionRangeSlider({
                    type: "double",
                    min: parseInt(_self.filterCMSparams.commerce_filter.price.min),
                    max: parseInt(_self.filterCMSparams.commerce_filter.price.max),
                    from: _self.filterCommerceDataBase.price[0],
                    to: _self.filterCommerceDataBase.price[1],
                    step: 1,
                    hide_min_max: true,
                    onChange: function (data) {
                        _self.$store.commit('FilterCommerce_update_base', {name: 'priceUpdate', param: 'rangeSlider', data: {min: data.from, max: data.to}})
                        _self.filterSalesItems(); 
                    },
                    // onUpdate: function (data) {
                    //     // console.log(data, 'update')
                    //     _self.$store.commit('FilterDataUpdate', {type: 'size-filter', min: data.from, max: data.to})
                    //     // _self.updateFilterDataBase();
                    // },
                });
                _self.LevelFilter.ionRangeSlider({
                    type: "double",
                    min: parseInt(_self.filterCMSparams.commerce_filter.level.min),
                    max: parseInt(_self.filterCMSparams.commerce_filter.level.max),
                    from: _self.filterCommerceDataBase.level[0],
                    to: _self.filterCommerceDataBase.level[1],
                    // step: 1,
                    hide_min_max: true,
                    onChange: function (data) {
                        if (data.from === 0) {
                            data.from = -1;
                        }
                        if (data.to === 0) {
                            data.to = 1
                        }
                        _self.$store.commit('FilterCommerce_update_base', {name: 'levelUpdate', param: 'rangeSlider', data: {min: data.from, max: data.to}})
                        _self.filterSalesItems(); 
                    },
                    // onUpdate: function (data) {
                    //     // console.log(data, 'update')
                    //     _self.$store.commit('FilterDataUpdate', {type: 'size-filter', min: data.from, max: data.to})
                    //     // _self.updateFilterDataBase();
                    // },
                });

            },
            // сброс всех range фильтров при динамических изменения данных мимальных и максимальных значениях фильтра
            updateIONrangeSlider() {
                var _self = this;
                _self.SizeFilter.data("ionRangeSlider").update({
                    from: _self.filterCommerceDataBase.size[0],
                    to: _self.filterCommerceDataBase.size[1],
                });
                _self.PriceFilter.data("ionRangeSlider").update({
                    from: _self.filterCommerceDataBase.price[0],
                    to: _self.filterCommerceDataBase.price[1],
                });
            },
            resetIONrangeSlider() {
                var _self = this;
                _self.SizeFilter.data("ionRangeSlider").update({
                    min: parseInt(_self.filterCMSparams.commerce_filter.size.min),
                    max: parseInt(_self.filterCMSparams.commerce_filter.size.max),
                    from: parseInt(_self.filterCMSparams.commerce_filter.size.min),
                    to: parseInt(_self.filterCMSparams.commerce_filter.size.max),
                });
                _self.PriceFilter.data("ionRangeSlider").update({
                    min: parseInt(_self.filterCMSparams.commerce_filter.price.min),
                    max: parseInt(_self.filterCMSparams.commerce_filter.price.max),
                    from: parseInt(_self.filterCMSparams.commerce_filter.price.min),
                    to: parseInt(_self.filterCMSparams.commerce_filter.price.max),
                });
            },
            filterSalesItems() {
                var commerceItems = this.commerceItemsDefault;
                console.log(commerceItems)                
                const filteredData = commerceItems.filter(item => {
                    return (!this.filterCommerceDataBase.complexChecked.length || this.filterCommerceDataBase.complexChecked.includes(item.project.slug)) &&
                           (!this.filterCommerceDataBase.partsChecked.length || this.filterCommerceDataBase.partsChecked.includes(item.part.value)) &&
                           (!this.filterCommerceDataBase.classChecked.length || this.filterCommerceDataBase.classChecked.includes(item.type.slug)) &&
                        //    (!this.filterCommerceDataBase.levelQuantities.length || this.filterCommerceDataBase.levelQuantities.includes(item.level)) &&
                           (parseFloat(item.size) >= this.filterCommerceDataBase.size[0] && parseFloat(item.size) <= this.filterCommerceDataBase.size[1]) &&
                           (parseFloat(item.price) >= this.filterCommerceDataBase.price[0] && parseFloat(item.price) <= this.filterCommerceDataBase.price[1]) &&
                           (item.level.some(value => parseInt(value) >= this.filterCommerceDataBase.level[0] && parseInt(value) <= this.filterCommerceDataBase.level[1])) &&
                           (this.filterCommerceDataBase.actions === false ? true : item.sales_init == this.filterCommerceDataBase.actions)
                });
                // console.log(filteredData)
                this.$store.commit('setCommerceItemsByShorting', {'shorting_params' : this.shortingParam, 'items' : filteredData});
            },
            reloadFilter() {
                this.$store.commit('setCommerceItemsByShorting', {'shorting_params' : this.shortingParam, 'items' : this.commerceItemsDefault});
                this.$store.commit('ReloadCommerceFilter');
                this.resetIONrangeSlider();
                // this.filterSalesItems();
            },  
            openMobileFilter() {
                this.$store.commit('OpenCommerceMobileFilter', true);
                document.getElementsByTagName('body')[0].classList.add('overlay-open');
                document.getElementById('header').classList.add('hideMobile');
                document.getElementById('footer').classList.add('hideMobile');
            },
            closeMobileFilter() {
                this.$store.commit('OpenCommerceMobileFilter', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                document.getElementById('header').classList.remove('hideMobile');
                document.getElementById('footer').classList.remove('hideMobile');
            },
            openMobileShorting() {
                this.$store.commit('OpenCommerceMobileShorting', true);
                document.getElementsByTagName('body')[0].classList.add('overlay-open');
                document.getElementById('header').classList.add('hideMobile');
                document.getElementById('footer').classList.add('hideMobile');
            },
        },
        beforeCreate() {
        },
        created () {
            // this.$store.commit('setCommerceItemsByShorting', {'shorting_params' : this.shortingParam, 'items' : this.commerceItems});
        },
        mounted () {
            this.BuildIonRangeSlider();
            this.$store.commit('setCommerceShortingParams', this.filterCMSparams.shorting_names.price_up);
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/filters/commerce-filter/commerce-filter.scss';
    @import '@/styles/components/filters/commerce-filter/respond/commerce-filter-respond.scss';
    // @import '@/styles/components/filters/sales-projects/respond/sales-filter-respond.scss';
</style>